export default __webpack_public_path__ + "static/media/garden-bg.feaf44f4.png";